import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import AuthWrapper1 from 'ui/AuthWrapper1';
import AuthCardWrapper from 'ui/AuthCardWrapper';
import Logo from 'ui/Logo';
import AuthRegister from './AuthRegister';
import AuthFooter from 'ui/AuthFooter';
import useAuth from 'hooks/useAuth';
import useCustomTranslation from 'hooks/useCustomTranslation';

// assets

// ===============================|| AUTH3 - REGISTER ||=============================== //

const Register = ({ plan } ) => {
  const theme = useTheme();
  const { getToken } = useAuth();
  const { invitationToken } = useParams();
  const [isValidToken, setIsValidToken] = useState(true);
  const [invitedEmail, setInvitedEmail] = useState('');
  console.log('Invite token:', invitationToken);
  if (plan) {
    localStorage.setItem("selectedPlan", JSON.stringify(plan));
    console.log(plan)
  }

  const parseResponse = async (response) => {
    const data = await response.json(); // ✅ Properly parse JSON
    console.log('Invite data fetched successfully:', data);
    if (data.invitation_created) {
      const inviteCreated = new Date(data.invitation_created);
      if (!inviteCreated) {
        console.error('Invite created date is not valid');
        return null;
      }
      const now = new Date();
      const INVITE_EXPIRATION_DAYS = 7;
      const expirationDate = new Date(inviteCreated.getTime() + INVITE_EXPIRATION_DAYS * 24 * 60 * 60 * 1000);
      if (now > expirationDate) {
        setIsValidToken(false);
        console.error('Invite token has expired');
        return null;
      }
      console.log(data.email);
      setInvitedEmail(data.email);
      console.log('Invite token is valid');
    }
  };

  const fetchInviteData = async () => {
    let url = `${process.env.REACT_APP_URL}/api/users/check-invite/${invitationToken}`;
    const token = await getToken();

    const headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${token}`);

    fetch(url, {
      method: 'GET',
      headers
    }).then(response => {
      console.log('Response:', response);
      if (!response.ok) {
        // throw new Error('Network response was not ok');
        console.error('Failed to fetch invite data:', response.statusText);
        return null;
      }
      parseResponse(response);
    }).catch(error => {
      console.error('Error fetching invite data:', error);
      return null;
    })
  };

  if (invitationToken) {
    // console.log('Register token:', invitationToken);
    fetchInviteData();
    // const expirationDate = new Date(now.getDate() + INVITE_EXPIRATION_DAYS);
  }

  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useCustomTranslation();
  return (
    <AuthWrapper1>
      <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <AuthCardWrapper>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                  <Grid item sx={{ mb: 3 }}>
                    <Logo />
                  </Grid>
                  {!isValidToken ? (
                    <>
                      <Grid item>
                        <Typography variant="subtitle1" color="error">
                          {t('This invitation link has expired or is invalid.')}
                        </Typography>
                      </Grid>
                      <Grid item container direction="column" alignItems="center" xs={12}>
                        <Typography
                          component={Link}
                          to='/register'
                          variant="subtitle1"
                          sx={{ textDecoration: 'none' }}
                        >
                          {t('Sign up with a new account')}
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <>

                      <Grid item xs={12}>
                        <Grid
                          container
                          direction={matchDownSM ? 'column-reverse' : 'row'}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Grid item>
                            <Stack alignItems="center" justifyContent="center" spacing={1}>
                              <Typography
                                color={theme.palette.primary.main}
                                gutterBottom
                                variant={matchDownSM ? 'h3' : 'h3'}
                              >
                                {t('Sign Up')}
                              </Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        {/* if invited, add employee */}
                        <AuthRegister registerProp={invitationToken ? 'employee' : 'company'} invitationToken={invitationToken} invitedEmail={invitedEmail} plan={plan} />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={12}>
                        <Grid item container direction="column" alignItems="center" xs={12}>
                          <Typography
                            component={Link}
                            to='/login'
                            variant="subtitle1"
                            sx={{ textDecoration: 'none' }}
                          >
                            {t('Already have an account?')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
          <AuthFooter />
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default Register;
